export default __webpack_public_path__ + "static/media/blog.31d422df.webp";